import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfigEstoqueRequest } from '../../requests/suprimentos/config-estoque.request';
import { ConfigEstoqueResponse } from '../../responses/suprimentos/config-estoque.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class ConfigEstoqueService extends CommonService {
  private readonly apiUrl: string = environment.urlApiSuprimentos + 'ConfiguracaoEstoque';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<ConfigEstoqueResponse> {
    return this.httpClient
      .get<ConfigEstoqueResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public post(request: ConfigEstoqueRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public put(idConfiguracaoEstoque: number, request: ConfigEstoqueRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/idConfiguracaoEstoque/${idConfiguracaoEstoque}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}